import * as React from "react"

import { StyledButton } from "./styles"
import { ButtonTypes } from "./types"

const Button: React.FC<ButtonTypes> = ({ children, ...props }) => {
  return <StyledButton {...props}>{children}</StyledButton>
}

export default Button
